__webpack_require__.p = "/drinkwatergoal/";